@if (isLink) {
	<a routerLink="/" class="flex items-center gap-3 group" [ngClass]="customClass">
		<span
			[ngClass]="[logoClasses, sizeClasses.logo]"
			class="font-cenzo font-bold tracking-tight transition-all duration-500 leading-none pb-2">OG</span>
		<span
			[ngClass]="[subtitleClasses, sizeClasses.subtitle]"
			class="font-cenzo tracking-[0.2em] font-medium transition-all duration-500 leading-tight text-left">HAIR<br/>STUDIO</span>
	</a>
} @else {
	<div class="flex items-center gap-3" [ngClass]="customClass">
		<span
			[ngClass]="[logoClasses, sizeClasses.logo]"
			class="font-cenzo font-bold tracking-tight transition-all duration-500 leading-none pb-2">OG</span>
		<span
			[ngClass]="[subtitleClasses, sizeClasses.subtitle]"
			class="font-cenzo tracking-[0.2em] font-medium transition-all duration-500 leading-tight text-left">HAIR<br/>STUDIO</span>
	</div>
}
